import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import useLocalization from "../../hooks/useLocalization";
import usePage from "../../hooks/usePage";
import useData from "../../hooks/useData";

import { Box, Stack, Button } from "@mui/material";

import Page from "./Page";
import Card from "../layout/Card";
import FileUpload from "../elements/FileUpload";

const SyndicationImportExport = () => {
  const { getTitle } = useLocalization();
  const location = useLocation();
  const navigate = useNavigate();
  const { addToWorkQueue } = useData();
  const { showMessage } = usePage();

  const [currentImport, setCurrentImport] = useState(null);

  const currentUserId = useSelector((state) => state.authentication.userId);
  const email = useSelector((state) => state.authentication.email);
  const syndicationId = location.state?.syndicationId;
  const name = location.state?.name || "Syndication";

  const handleExportSelection = async (selection) => {
    switch (selection) {
      case "exportTerritories":
        await queueFile("exportSyndicationTerritories");
        break;
      case "exportLocations":
        await queueFile("exportSyndicationLocations");
        break;
      default:
        break;
    }
  };

  const queueFile = async (workType) => {
    await addToWorkQueue(workType, {
      syndicationId,
      email,
      userId: currentUserId,
    });

    showMessage("Your file will be emailed to you shortly.");
  };

  const handleImportSelection = (selection) => {
    setCurrentImport(selection);
  };

  const handleUploaded = () => {
    showMessage("You will receive an email on completion.");
    setCurrentImport(null);
  };

  const handleToolbarClick = (action) => {
    switch (action) {
      case "back":
        navigate("/syndication", { state: { syndicationId } });
        break;
      default:
        break;
    }
  };

  return (
    <Page
      pageName="Syndication Imports & Exports"
      entityName={name}
      includeToolbar
      items={[
        {
          name: "back",
          iconName: "ArrowCircleLeft",
        },
      ]}
      onToolItemClick={handleToolbarClick}
    >
      <Box
        sx={{ display: "flex" }}
        gap={1}
      >
        <Card
          title={getTitle("exports")}
          sx={{ width: "300px" }}
        >
          <Stack>
            <Box>
              <Button
                onClick={() => handleExportSelection("exportTerritories")}
              >
                Territory Export
              </Button>
            </Box>
            <Box>
              <Button onClick={() => handleExportSelection("exportLocations")}>
                Location Export
              </Button>
            </Box>
          </Stack>
        </Card>

        <Card
          title={getTitle("imports")}
          sx={{ width: "300px" }}
        >
          <Stack>
            <Box>
              <Button
                onClick={() =>
                  handleImportSelection("importSyndicationTerritories")
                }
              >
                Territory Import
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() =>
                  handleImportSelection("importSyndicationLocations")
                }
              >
                Location Import
              </Button>
            </Box>
          </Stack>
        </Card>

        {currentImport !== null && (
          <Card
            title={
              currentImport === "importSyndicationTerritories"
                ? "Territory Import"
                : "Location Import"
            }
            sx={{ width: "300px" }}
          >
            <Box padding="10px">
              <FileUpload
                entityName="Syndication"
                entityId={syndicationId}
                data={{
                  workType: currentImport,
                  syndicationId: syndicationId,
                  userId: currentUserId,
                  email: email,
                }}
                onUploaded={handleUploaded}
              />
            </Box>
          </Card>
        )}
      </Box>
    </Page>
  );
};

export default SyndicationImportExport;
